import React, { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supportedLanguages, defaultLanguage } from '../i18n';

const LanguageWrapper: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  const isValidLang = lang && (supportedLanguages as readonly string[]).includes(lang);

  useEffect(() => {
    if (isValidLang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, isValidLang]);

  useEffect(() => {
    if (isValidLang) {
      document.documentElement.lang = lang as string;
    }
  }, [lang, isValidLang]);

  if (!isValidLang) {
    return <Navigate to={`/${defaultLanguage}`} replace />;
  }

  return <Outlet />;
};

export default LanguageWrapper;
